export default {
  methods: {
    showNotification(status, msg) {
      const _self = this;
      const module = {
        info() {
          _self.$toast.info(msg, {
            closeOnClick: true,
            icon: "fas fa-info-circle",
          });
        },
        success: function () {
          _self.$toast.success(msg, {
            closeOnClick: true,
            icon: "fas fa-check-circle",
          });
        },
        warning: function () {
          _self.$toast.warning(msg, {
            closeOnClick: true,
            icon: "fas fa-exclamation-triangle",
          });
        },
        error: function () {
          _self.$toast.error(msg, {
            closeOnClick: true,
            icon: "fas fa-exclamation-circle",
          });
        },
      };
      module[status]();
    },
  },
};
